import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/admin/AdminLogin";
import Unauthorized from "@/pages/admin/Unauthorized";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminAppointments from "@/pages/admin/AdminAppointments";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminReminders from "@/pages/admin/AdminReminders";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminLayout from "@/components/admin/AdminLayout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

function AppRouter() {
  return (
    <Routes>
      {/* Public site */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      {/* Admin auth screens (unprotected) */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/unauthorized" element={<Unauthorized />} />

      {/* Admin (protected) */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="notifications" element={<AdminNotifications />} />
        <Route path="appointments" element={<AdminAppointments />} />
        <Route path="contact" element={<AdminContacts />} />
        <Route path="reminders" element={<AdminReminders />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <FloatingWhatsApp
        phoneNumber="919884042552"
        message="Hello! How can I help you today?"
      />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1B4332",
            color: "#FAF6EC",
            border: "1px solid #C9A84C",
            fontFamily: "'Jost', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
